import { render } from "./MyPokemonDetail.vue?vue&type=template&id=20e7277c&scoped=true"
import script from "./MyPokemonDetail.vue?vue&type=script&lang=js"
export * from "./MyPokemonDetail.vue?vue&type=script&lang=js"

import "./MyPokemonDetail.vue?vue&type=style&index=0&id=20e7277c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7277c"]])

export default __exports__